module.exports = __webpack_public_path__ + "img/product-chemical.20252ad7.svg";